import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [authed, setAuthed] = useState(location.state?.user ? true : null);

  useEffect(() => {
    if (location.state?.user) return;
    const check = async () => {
      try {
        await api.get("/auth/me");
        setAuthed(true);
      } catch (err) {
        setAuthed(false);
        navigate("/admin/login");
      }
    };
    check();
  }, [location.state, navigate]);

  if (authed === null) {
    return (
      <div className="min-h-screen grid place-items-center bg-[#F9F9F8]">
        <Loader2 className="animate-spin text-[#0033A0]" size={32} />
      </div>
    );
  }
  if (authed === false) return null;
  return children;
}
